export const BriefedCtcMetricColumnName = 'channel';
